export default __webpack_public_path__ + "static/media/imgLight2.f8c462af.png";